/* eslint-disable import/no-named-default */
// import { getQrCodeData } from './chinlai/template/scanData'
import { getBarCodeData } from './sdgrouphub/template/scanData'

export const customGetQrCodeData = {} // {} getQrCodeData
export const customGetBarCodeData = getBarCodeData // {} getBarCodeData